import { patch } from 'bootstrap/load-snabbdom';
import { ITrackingObject, IChatType, GenesysChatStyle } from './models';
import $ from 'jquery';

import { Hooks } from 'snabbdom/hooks';

import 'bootstrap/load-terrific';

const hooks : Hooks = {
	insert(vnode) {
		window.application.sandbox.addModules($(vnode.elm as HTMLElement));
	},
};

function LivepersonChat({
	chatType,
	trackingConfig,
} : {
	chatType : IChatType;
	trackingConfig : ITrackingObject;
}) {
	const cssClasses = chatType === 'general' ? 'modLivePersonChat' : 'mod modLivePersonChatForContact';

	return <div className={cssClasses}
			id={chatType === 'general' ? 'lpChatGeneralButton' : ''}
			attrs-data-connectors={chatType === 'contact' ? 'sdxContactWizard,contactWizard' : ''}
			attrs-data-conversion-category={trackingConfig['data-conversion-category']}
			attrs-data-conversion-detail={trackingConfig['data-conversion-detail']}
			attrs-data-conversion-class={trackingConfig['data-conversion-class']}
			attrs-data-track-action={trackingConfig['data-track-action']}
			attrs-data-track-category={trackingConfig['data-track-category']}
			attrs-data-track-label={trackingConfig['data-track-label']}
			attrs-data-track-linkname={trackingConfig['data-track-linkname']}
			attrs-data-track-location={trackingConfig['data-track-location']}>
	</div>;
}

function GenesysChat({
	chatId,
	chatType,
	trackingConfig,
} : {
	chatId : GenesysChatStyle;
	chatType : IChatType;
	trackingConfig : ITrackingObject;
}) {
	const cssClasses = chatType === 'general' ? '' : 'mod modGenesysChatForContact';

	return <div
			className={cssClasses}
			id={chatId}
			attrs-data-connectors={chatType === 'contact' ? 'sdxContactWizard' : ''}
			attrs-data-conversion-category={trackingConfig['data-conversion-category']}
			attrs-data-conversion-detail={trackingConfig['data-conversion-detail']}
			attrs-data-conversion-class={trackingConfig['data-conversion-class']}
			attrs-data-track-action={trackingConfig['data-track-action']}
			attrs-data-track-category={trackingConfig['data-track-category']}
			attrs-data-track-label={trackingConfig['data-track-label']}
			attrs-data-track-linkname={trackingConfig['data-track-linkname']}
			attrs-data-track-location={trackingConfig['data-track-location']}>
	</div>;
}


function Chat({
	title,
	introductionText,
	chatType,
	chatId,
	chatProvider,
	trackingConfig,
} : {
	title : string;
	introductionText : string;
	chatType : IChatType;
	chatId : GenesysChatStyle;
	chatProvider : string;
	trackingConfig : ITrackingObject;
}) {
	return <div hook={hooks}>
		{title &&
			<h4 className="sc-navy margin-bottom-3">{title}</h4>
		}
		{introductionText &&
			<div className="introduction-text margin-bottom-2"
				innerHTML={introductionText}>
			</div>
		}
		{chatProvider === 'liveperson' &&
			<LivepersonChat
				chatType={chatType}
				trackingConfig={trackingConfig}
			/>
		}
		{chatProvider === 'genesys' &&
			<GenesysChat
				chatId={chatId}
				chatType={chatType}
				trackingConfig={trackingConfig}
			/>
		}
	</div>;
}

export function renderChat(
	target : HTMLElement,
	title : string,
	introductionText : string,
	chatType : IChatType,
	chatId : GenesysChatStyle,
	chatProvider : string,
	trackingConfig : ITrackingObject,
) {
	return patch(
		target,
		<Chat
			title={title}
			introductionText={introductionText}
			chatType={chatType}
			chatId={chatId}
			chatProvider={chatProvider}
			trackingConfig={trackingConfig}
		/>,
	);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/Chat.tsx